import { rootSelector } from '../selectors';
import { createSelector } from 'reselect';
import { int64 } from '@fullstory/proto/google/protobuf';
import { AppState } from '@fullstory/redux';

// This selector serves as a dependency of other selectors that need installed integration data. If we pass the root
// selector to every selector, any updates will break memoization for the others, which can easily lead to infinite
// loops that can crash the app.
export const getAllSignals = createSelector(rootSelector, settings => settings.signals.signals);

export const getSignalById = createSelector(
  [getAllSignals, (_: AppState, signalId: int64) => signalId],
  (signals, signalId) => signals.find(signal => signal.signalId === signalId),
);
